import Action from "../base/action";

class MoveAndRotate extends Action {
    model;
    moveSteps;

    constructor(props) {
        super(props);
        this.transitionValues = props.transitionValues;
        this.model = props.model;
        this.moveSteps = props.moveSteps;
        this._moveStepWaitTimeoutId = null;
        this._moveStepWaitResolve = null;
    }

    _waitMoveStep(ms) {
        return new Promise((resolve) => {
            this._moveStepWaitResolve = resolve;
            this._moveStepWaitTimeoutId = setTimeout(() => {
                this._clearMoveStepWaitHandles();
                resolve(false);
            }, ms);
        });
    }

    _clearMoveStepWaitHandles() {
        this._moveStepWaitTimeoutId = null;
        this._moveStepWaitResolve = null;
    }

    cancelPendingMoveStepWait() {
        if (this._moveStepWaitTimeoutId != null) {
            clearTimeout(this._moveStepWaitTimeoutId);
        }
        const resolve = this._moveStepWaitResolve;
        this._clearMoveStepWaitHandles();
        if (resolve) {
            resolve(true);
        }
    }

    async execute() {
        throw new Error("subclass responsibility");
    }

    getComposedMatrix(index = 0) {
        const item = this.moveSteps[index];
        const position = new THREE.Vector3(...item.position);
        const quaternion = new THREE.Quaternion(...item.quaternion);
        const scale = new THREE.Vector3(...item.scale);
        
        return new THREE.Matrix4().compose(position, quaternion, scale);
    }

    getPivot(index = 0) {
        const pivot = this.moveSteps[index].pivot;
        return pivot ? new THREE.Vector3(...pivot) : null;
    }

    getAnimateTime(index = 0) {
        return parseFloat(this.moveSteps[index].animateTime) || 0;
    }
}

export default MoveAndRotate;
